// ABOUTME: One-line diagnostic label for the Crossing: the current screen, and whether the steersman strip has a tip
// ABOUTME: for that screen. Hidden from assistive tech; shown in every build until it is removed.

import { Box } from '@mui/material';

interface CrossingDevLabelProps {
  screenId?: string;
  name?: string;
  tips: Record<string, { text: string }>;
  showSteersman: boolean;
}

export default function CrossingDevLabel({ screenId, name, tips, showSteersman }: CrossingDevLabelProps) {
  // The same test SteersmanStrip applies, so "found" here means the strip has text for this ID.
  const tipFound = !!screenId && !!tips[screenId]?.text;
  const tip = !screenId
    ? 'tip: none'
    : `tip: ${screenId} ${tipFound ? 'found' : 'none'}${tipFound && !showSteersman ? ' (hidden: steersman off)' : ''}`;
  const parts = [
    [screenId || '?', name].filter(Boolean).join(' '),
    tip,
  ].filter(Boolean);

  return (
    <Box
      data-testid="crossing-dev-label"
      aria-hidden="true"
      sx={{ fontFamily: 'monospace', fontSize: '11px', lineHeight: 1.4, px: 1, py: 0.25, bgcolor: 'grey.200', color: 'grey.900', pointerEvents: 'none', overflowWrap: 'anywhere' }}
    >
      {parts.join(' · ')}
    </Box>
  );
}
